import Rater from "./Rater.js";
import CompanyLocation from "./CompanyLocation.js";
import SocialData from "./SocialData.js";
import Review from "./Review.js";
import Event from "./Event.js";

export default class Company {
  constructor(
    id,
    companyId,
    name,
    aboutCompany,
    urlOfBackground,
    urlOfLogo,
    fieldOfActivity,
    website,
    email,
    specifics,
    regionId,
    vacancyCount,
    rating,
    companyCulture = 5.0,
    compensationBenefits = 5.0,
    management = 5.0,
    professionalSkills = 5.0,
    worklifeBalance = 5.0,
    perksAndBenefits = [],
    raters = [],
    companyLocation,
    social = null,
    reviews = [],
    picturesOfCompany = [],
    events = [],
    isFollowed = false,
    alternativeNames = []
  ) {
    this.id = id;
    this.companyId = companyId;
    this.name = name;
    this.aboutCompany = aboutCompany;
    this.urlOfBackground = urlOfBackground;
    this.urlOfLogo = urlOfLogo;
    this.fieldOfActivity = fieldOfActivity;
    this.website = website;
    this.email = email;
    this.specifics = specifics;
    this.regionId = regionId;
    this.vacancyCount = vacancyCount;
    this.rating = Number(rating ?? 0) || 0;
    this.companyCulture = Number(companyCulture ?? 5.0) || 0;
    this.compensationBenefits = Number(compensationBenefits ?? 5.0) || 0;
    this.management = Number(management ?? 5.0) || 0;
    this.professionalSkills = Number(professionalSkills ?? 5.0) || 0;
    this.worklifeBalance = Number(worklifeBalance ?? 5.0) || 0;
    this.perksAndBenefits = perksAndBenefits;
    this.raters = raters.map((rater) => Rater.fromJson(rater));
    this.companyLocation = companyLocation;
    this.social = social;
    this.reviews = reviews.map((review) => Review.fromJson(review));
    this.picturesOfCompany = picturesOfCompany;
    this.events = events.map((event) => Event.fromJson(event));
    this.isFollowed = isFollowed;
    this.alternativeNames = alternativeNames;
  }

  static fromJson(json) {
    const cultureLatin = json.company_culture;
    const cultureCyrillic = json.company_сulture;

    const social = json.social
      ? new SocialData(
          json.social.facebook_id,
          json.social.facebook_enabled,
          json.social.twitter_id,
          json.social.twitter_enabled,
          json.social.instagram_id,
          json.social.instagram_enabled
        )
      : null;

    return new Company(
      json.id,
      json.company_id,
      json.name,
      json.about_company,
      json.url_of_background,
      json.url_of_logo,
      json.field_of_activity,
      json.website,
      json.email,
      json.specifics,
      json.region_id,
      json.vacancy_count,
      json.rating ?? 5.0,
      cultureLatin ?? cultureCyrillic ?? 5.0,
      json.compensation_benefits ?? 5.0,
      json.managment ?? 5.0,
      json.professional_skills ?? 5.0,
      json.worklife_balance ?? 5.0,
      json.perks_and_benefits || [],
      json.raters || [],
      json.company_location
        ? CompanyLocation.fromJson(json.company_location)
        : null,
      social,
      json.reviews || [],
      json.pictures_of_company || [],
      json.events || [],
      json.is_followed === true,
      json.alternative_names || []
    );
  }
}